import { AxiosPromise } from 'axios';
import { apiService } from '@app/services';

class OnboardService {
    readonly apiBase: string = '/api/profile/me/onboarding';

    onboardingStatus(handleError: Function, handleSuccess: Function): AxiosPromise {
        return apiService.get(`${this.apiBase}/status`,
            { onError: handleError, onSuccess: handleSuccess, local: true }
        )
            .catch();
    }

    getFullToken(handleError: Function, handleSuccess: Function): AxiosPromise {
        return apiService.get(`${this.apiBase}/token`,
            { onError: handleError, onSuccess: handleSuccess, local: true }
        )
            .catch();
    }

    setPasswordFromOnboarding(newPassword: string, handleError: Function, handleSuccess: Function): AxiosPromise {
        const jsonObject: any = {
            currentPassword: null,
            newPassword: newPassword,
            isSetPassword: false
        };

        return apiService.put(`${this.apiBase}/password`, jsonObject,
            { onError: handleError, onSuccess: handleSuccess, local: true }
        )
            .catch();
    }
}

export const onboardService = new OnboardService();